/** Значение куки по имени; null, если куки нет или кода нет в браузере. */
export function readCookie(name: string): string | null {
  if (typeof document === 'undefined') {
    return null;
  }
  const escaped = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const m = document.cookie.match(
    new RegExp('(?:^|; )' + escaped + '=([^;]*)')
  );
  return m ? decodeURIComponent(m[1]) : null;
}
